<div class="signin-content">
  <mat-card appearance="outlined" class="example-card">
    <div style="display: flex; flex-direction: column; align-items: center;">

      <div>
        <img ngSrc="../../assets/bannerlogo.png" class="cloud_service_logo" alt="cloud_service_logo" width="560" height="120">
      </div>

      @if (isLinkValid) {
        <div>
          <h2 style="margin-bottom: 30px;" i18n="@@pages.joinSection.title.invited">GOKURIに招待されました</h2>
        </div>

        <p class="bmargin15" i18n="@@pages.joinSection.message.existingAccount">すでにスタッフアカウントをお持ちの方はこちら</p>

        <div class="btn_login">
          @if (!loginDisplay) {
            <button mat-raised-button color="primary" (click)="login()" [disabled]="waitingForResult" i18n="@@pages.joinSection.button.login">ログイン</button>
          } @else {
            <button mat-raised-button color="primary" (click)="registerExistingUser()" [disabled]="waitingForResult">{{storeAuth.getLoginUserName()}} としてログイン</button>
          }
        </div>

        <p style="text-align: center; margin-top: 20px;margin-bottom:20px;" i18n="@@pages.joinSection.message.createAccount">
          スタッフアカウントをお持ちでない方は<br>こちらからスタッフアカウントを作成して下さい。
        </p>

        <div class="row-area">
          <form [formGroup]="joinSectionForm" novalidate (ngSubmit)="submit(joinSectionForm.value)" style="display: flex; flex-direction: column; flex: 1; gap: 5px;">

            <mat-form-field appearance="outline">
              <input matInput formControlName="signInNames" placeholder="ユーザID" i18n-placeholder="@@pages.joinSection.placeholder.userId" />
              @if (signInNamesFormControl.hasError('required')) {
                <mat-error i18n="@@pages.joinSection.error.userIdRequired">
                  <strong>必須項目</strong> です
                </mat-error>
              }
              @if (signInNamesFormControl.hasError('pattern')) {
                <mat-error i18n="@@pages.joinSection.error.userIdPattern">
                  <strong>英字</strong>で始まり、<strong>英数字またはハイフンのみ</strong>が使用できます
                </mat-error>
              }
              @if (signInNamesFormControl.hasError('minlength')) {
                <mat-error i18n="@@pages.joinSection.error.userIdMinLength">
                  <strong> 8文字以上</strong> で入力してください
                </mat-error>
              }
              @if (signInNamesFormControl.hasError('maxlength')) {
                <mat-error i18n="@@pages.joinSection.error.userIdMaxLength">
                  <strong>32文字以下</strong> で入力してください
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <input matInput formControlName="loginPassword" [type]="hide ? 'password' : 'text'" placeholder="ログインパスワード" i18n-placeholder="@@pages.joinSection.placeholder.password" />
              <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              @if (loginPasswordFormControl.hasError('required')) {
                <mat-error i18n="@@pages.joinSection.error.passwordRequired">
                  <strong>必須項目</strong> です
                </mat-error>
              }
              @if (loginPasswordFormControl.hasError('pattern')) {
                <mat-error i18n="@@pages.joinSection.error.passwordPattern">
                  <strong>小文字、大文字、数字、記号の 4 種類</strong> で入力してください
                </mat-error>
              }
              @if (loginPasswordFormControl.hasError('minlength')) {
                <mat-error i18n="@@pages.joinSection.error.passwordMinLength">
                  <strong> 8文字以上</strong> で入力してください
                </mat-error>
              }
              @if (loginPasswordFormControl.hasError('maxlength')) {
                <mat-error i18n="@@pages.joinSection.error.passwordMaxLength">
                  <strong>64文字以下</strong> で入力してください
                </mat-error>
              }
            </mat-form-field>

            <div class="name-row">
              <mat-form-field appearance="outline" class="name-field">
                <mat-label i18n="@@pages.joinSection.placeholder.lastName">氏</mat-label>
                <input matInput formControlName="lastName" />
                @if (lastNameFormControl.hasError('required')) {
                  <mat-error i18n="@@pages.joinSection.error.lastNameRequired">
                    <strong>必須項目</strong> です
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" class="name-field">
                <mat-label i18n="@@pages.joinSection.placeholder.firstName">名</mat-label>
                <input matInput formControlName="firstName" />
                @if (firstNameFormControl.hasError('required')) {
                  <mat-error i18n="@@pages.joinSection.error.firstNameRequired">
                    <strong>必須項目</strong> です
                  </mat-error>
                }
              </mat-form-field>
            </div>
<!-- 
            <div class="name-row">
              <mat-form-field appearance="outline" class="name-field">
                <mat-label i18n="@@pages.joinSection.placeholder.lastNameEN">氏（ローマ字）</mat-label>
                <input matInput formControlName="lastNameEN" />
                @if (lastNameENFormControl.hasError('required')) {
                  <mat-error i18n="@@pages.joinSection.error.lastNameENRequired">
                    <strong>必須項目</strong> です
                  </mat-error>
                }
                @if (lastNameENFormControl.hasError('pattern')) {
                  <mat-error i18n="@@pages.joinSection.error.lastNameENPattern">
                    <strong>ローマ字のみ</strong> 入力してください
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" class="name-field">
                <mat-label i18n="@@pages.joinSection.placeholder.firstNameEN">名（ローマ字）</mat-label>
                <input matInput formControlName="firstNameEN" />
                @if (firstNameENFormControl.hasError('pattern')) {
                  <mat-error i18n="@@pages.joinSection.error.firstNameENPattern">
                    <strong>ローマ字のみ</strong> 入力してください
                  </mat-error>
                }
              </mat-form-field>
            </div> -->

            <button mat-raised-button [disabled]="!joinSectionForm.valid || waitingForResult" color="primary" style="margin-top: 10px;" i18n="@@pages.joinSection.button.createStaffAccount">
              スタッフアカウント作成
            </button>
          </form>
        </div>
      } @else {
        <div style="margin: 30px 0; text-align: center;">
          <h2 style="margin-bottom: 16px;">{{invalidMessage}}</h2>
          <p style="color: var(--gokuri-text-secondary);" i18n="@@pages.joinSection.message.contactAdmin">
            招待者に再度招待を依頼してください。
          </p>
        </div>
      }
    </div>
  </mat-card>

  @if (debugMode) {
    <div class="debug-panel" [class.debug-panel--collapsed]="debugPanelCollapsed">
      <div class="debug-panel__header" (click)="debugPanelCollapsed = !debugPanelCollapsed">
        <mat-icon>bug_report</mat-icon>
        <span>Debug Panel (dev only)</span>
        <span style="flex: 1;"></span>
        <mat-icon>{{ debugPanelCollapsed ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>

      @if (!debugPanelCollapsed) {
        <div class="debug-panel__section">
          <div class="debug-panel__label">Success scenarios</div>
          <div class="debug-panel__buttons">
            <button mat-stroked-button (click)="debugSimulateNewUserSuccess()">New user success (navigate)</button>
            <button mat-stroked-button (click)="debugSimulateExistingUserSuccess()">Existing user success (dialog)</button>
            <button mat-stroked-button (click)="debugSimulateSectionGroupAdminSuccess()">SG Admin success (dialog)</button>
            <button mat-stroked-button (click)="debugSimulateSystemAdminSuccess()">System Admin success (dialog)</button>
          </div>
        </div>

        <div class="debug-panel__section">
          <div class="debug-panel__label">Error dialogs</div>
          <div class="debug-panel__buttons">
            <button mat-stroked-button (click)="debugSimulateDuplicateUserId()">Duplicate User ID (dialog)</button>
            <button mat-stroked-button (click)="debugSimulateAlreadyBelongs()">Already belongs (dialog)</button>
          </div>
        </div>

        <div class="debug-panel__section">
          <div class="debug-panel__label">Link status (blocks UI)</div>
          <div class="debug-panel__buttons">
            <button mat-stroked-button color="warn" (click)="debugSimulateLinkExpired()">Link expired</button>
            <button mat-stroked-button color="warn" (click)="debugSimulateLinkInvalid()">Link invalid</button>
            <button mat-stroked-button color="warn" (click)="debugSimulateLinkCanceled()">Link canceled</button>
          </div>
        </div>

        <div class="debug-panel__section">
          <div class="debug-panel__label">Other</div>
          <div class="debug-panel__buttons">
            <button mat-stroked-button (click)="debugSimulateUnknownError()">Unknown error (snackbar)</button>
            <button mat-flat-button color="primary" (click)="debugReset()">Reset state</button>
          </div>
        </div>

        <div class="debug-panel__state">
          isLinkValid: {{ isLinkValid }} | waitingForResult: {{ waitingForResult }} | loginDisplay: {{ loginDisplay }}
        </div>
      }
    </div>
  }
</div>
